export default "__VITE_ASSET__CMjRbz1G__"